<script>
  import { format } from 'svelte-i18n';

  import { Icon } from '@client/components/icon';
  import { Switch } from '@client/components/switch';

  import { USER_SETTINGS_NOTIFICATIONS } from '@client/enums';

  import { merge } from '@common/utils/objects';

  import { TabContent, TabPane } from '@sveltestrap/sveltestrap';

  export let expandAll = false;
  export let isUser = true;
  export let settings = {};
  export let onUpdate = () => {};

  const onChange = (id, label, checked) => {
    if (onUpdate) {
      onUpdate((isUser ? 'usersettings-' : 'defaultnotificationsettings-') + id, $format(label), checked);
    }
  };

  const notifications = merge({}, USER_SETTINGS_NOTIFICATIONS);

  let activeTab = null;
  let innerWidth = 0;
  let isMobile = false;

  if (expandAll) {
    Object.keys(notifications).forEach((key) => {
      notifications[key].expanded = true;
    });
  }

  $: hasAutoTrackLinks = settings?.autotracklinks;
  $: hasAutoTrackDocs = settings?.autotrackdocs;
  $: hasAutoTrackEmails = settings?.autotrackemails;

  $: activeTabs = [hasAutoTrackLinks && 'links', hasAutoTrackDocs && 'docs', hasAutoTrackEmails && 'emails'].filter(
    Boolean
  );

  $: if (!activeTabs.includes(activeTab) && activeTabs.length > 0) {
    activeTab = activeTabs[0];
  }

  $: isMobile = innerWidth <= 600;
</script>

<svelte:window bind:innerWidth />

<div class="user-notifications">
  {#if !((hasAutoTrackLinks || hasAutoTrackDocs || hasAutoTrackEmails) && isUser) || !isUser}
    <p class="pt-2">{$format('label.DISABLED_NOTIFICATIONS')}</p>
  {/if}
  {#key activeTab}
    <TabContent pills>
      {#if (hasAutoTrackEmails && isUser) || !isUser}
        <TabPane
          tabId="emailEvents"
          tab={isMobile ? $format('label.EMAILS') : $format('label.EMAIL_EVENTS')}
          active={activeTab === 'emails'}
        >
          <div class="sync-entries">
            {#each ['sent', 'view', 'video'] as item}
              <div class="sync-entry group">
                <div
                  class="sync-name"
                  on:click={() => (notifications[item].expanded = !notifications[item].expanded)}
                  role="button"
                  tabindex="0"
                >
                  <Icon name={notifications[item].expanded ? 'chevron-down' : 'chevron-right'} />
                  <div>{$format(notifications[item].label)}</div>
                </div>
                <div class="sync-actions">
                  {Object.entries(notifications[item].items).length} items
                </div>
              </div>

              {#if notifications[item].expanded}
                {#each Object.entries(notifications[item].items) as [key]}
                  <div class="sync-entry expanded">
                    <div class="sync-name">
                      <div>{$format(notifications[item].items[key].label)}</div>
                    </div>
                    <div class="sync-actions">
                      <Switch
                        on:change={() => onChange(key, notifications[item].items[key].label, settings[key])}
                        bind:checked={settings[key]}
                      />
                    </div>
                  </div>
                {/each}
              {/if}
            {/each}
          </div>
        </TabPane>
      {/if}
      {#if (hasAutoTrackLinks && isUser) || !isUser}
        <TabPane
          tabId="trackingEvents"
          tab={isMobile ? $format('label.TRACKING') : $format('label.TRACKING_EVENTS')}
          active={activeTab === 'links'}
        >
          <div class="sync-entries">
            {#each ['ad', 'link', 'website'] as item}
              <div class="sync-entry group">
                <div
                  class="sync-name"
                  on:click={() => (notifications[item].expanded = !notifications[item].expanded)}
                  role="button"
                  tabindex="0"
                >
                  <Icon name={notifications[item].expanded ? 'chevron-down' : 'chevron-right'} />
                  <div>{$format(notifications[item].label)}</div>
                </div>
                <div class="sync-actions">
                  {Object.entries(notifications[item].items).length} items
                </div>
              </div>

              {#if notifications[item].expanded}
                {#each Object.entries(notifications[item].items) as [key]}
                  <div class="sync-entry expanded">
                    <div class="sync-name">
                      <div>{$format(notifications[item].items[key].label)}</div>
                    </div>
                    <div class="sync-actions">
                      <Switch
                        on:change={() => onChange(key, notifications[item].items[key].label, settings[key])}
                        bind:checked={settings[key]}
                      />
                    </div>
                  </div>
                {/each}
              {/if}
            {/each}
          </div>
        </TabPane>
      {/if}
      {#if (hasAutoTrackDocs && isUser) || !isUser}
        <TabPane
          tabId="attachmentEvents"
          tab={isMobile ? $format('label.ATTACHMENT') : $format('label.ATTACHMENT_EVENTS')}
          active={activeTab === 'docs'}
        >
          <div class="sync-entries">
            {#each ['attachmentdownload', 'attachmentview'] as item}
              <div class="sync-entry group">
                <div
                  class="sync-name"
                  on:click={() => (notifications[item].expanded = !notifications[item].expanded)}
                  role="button"
                  tabindex="0"
                >
                  <Icon name={notifications[item].expanded ? 'chevron-down' : 'chevron-right'} />
                  <div>{$format(notifications[item].label)}</div>
                </div>
                <div class="sync-actions">
                  {Object.entries(notifications[item].items).length} items
                </div>
              </div>

              {#if notifications[item].expanded}
                {#each Object.entries(notifications[item].items) as [key]}
                  <div class="sync-entry expanded">
                    <div class="sync-name">
                      <div>{$format(notifications[item].items[key].label)}</div>
                    </div>
                    <div class="sync-actions">
                      <Switch
                        on:change={() => onChange(key, notifications[item].items[key].label, settings[key])}
                        bind:checked={settings[key]}
                      />
                    </div>
                  </div>
                {/each}
              {/if}
            {/each}
          </div>
        </TabPane>
      {/if}
    </TabContent>
  {/key}
</div>

<style lang="scss" src="./user-notifications.scss"></style>
